<rk-mobile-right-page-wrapper (cancelled)="hide()">
  <ng-container *ngIf="track$ | async as track">
    <div class="absolute z-10 p-2 right-2 top-4" (click)="openContextMenu()">
      <mat-icon fontSet="fa" fontIcon="fa-ellipsis-vertical"></mat-icon>
    </div>
    <div class="bg-cover"></div>
    <div class="cover-container">
      <img [src]="track.cover" alt="" class="cover" />
      <div class="play" (click)="playTrack(track)">
        <mat-icon
          fontSet="fa"
          [fontIcon]="
            trackPlaying(track, currentTrackPlaying$ | async, isPlaying$ | async)
              ? 'fa-pause'
              : 'fa-play'
          "
        ></mat-icon>
      </div>
    </div>
    <div class="main-info">
      <div class="title">{{ track.title }}</div>
      <div class="artist">{{ track.artist }}</div>
      <div class="tags" *ngIf="track.tags.length">
        <div class="tag" *ngFor="let tag of track.tags | slice: 0 : 5">
          {{ tag.name }}
        </div>
      </div>
    </div>
    <div class="other-info">
      <div>
        <div class="info-title" translate>MEDIA.COLUMNS.ALBUM</div>
        <div class="info-value">{{ track.album ? track.album : '-' }}</div>
      </div>
      <div>
        <div class="info-title" translate>MEDIA.COLUMNS.YEAR</div>
        <div class="info-value">{{ track.year ?? '-' }}</div>
      </div>
      <div>
        <div class="info-title" translate>MEDIA.EDIT_TRACK.BUY_LINK</div>
        <div class="info-value overflow-hidden">
          <a
            class="overflow-hidden overflow-ellipsis block whitespace-nowrap"
            *ngIf="track.buyLink; else noLink"
            [href]="track.buyLink"
          >
            {{ track.buyLink }}
          </a>
          <ng-template #noLink><div class="info-value">-</div></ng-template>
        </div>
      </div>
      <div>
        <div class="info-title">BPM</div>
        <div class="info-value">{{ track.bpm ?? '-' }}</div>
      </div>
    </div>
    <rk-library-track-edit
      *ngIf="$editing()"
      [desktop]="false"
      class="absolute top-0 w-full z-20 bg-gray-hover"
      [class.closing]="$closing()"
    ></rk-library-track-edit>
  </ng-container>
</rk-mobile-right-page-wrapper>
